// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#create .v-speed-dial[data-v-54fa17d9]{position:absolute;z-index:10}#create .v-btn--floating[data-v-54fa17d9]{position:relative}", ""]);
// Exports
module.exports = exports;
